<script setup lang="ts">
import type { Breadcrumbs } from '@@/shared/application';

definePageMeta({
  pageTemplate: 'search_page',
  pageType: 'collaborator',
});

const { t } = useI18n();

useHead({
  title: t(`agent.search_form.meta_title`),
  meta: [
    { property: `og:title`, content: t(`agent.search_form.meta_title`) },
    { name: `description`, content: t(`agent.search_form.meta_description`) },
    { property: `og:description`, content: t(`agent.search_form.meta_description`) },
  ],
});

const breadcrumbs = computed<Breadcrumbs>(() => [
  { text: t(`agent.search_form.breadcrumb.find_agent`), id: `find_agent` },

]);
</script>

<template>
  <div class="flex flex-col gap-m pb-m">
    <FindAgentForm />
    <FindAgentContent />
    <AgentSectionPropertips />
    <div class="flex flex-col gap-2xl py-2xl">
      <FindAgentReinsurance />
      <FindAgentFaq />
    </div>
    <IadWrapper>
      <IadBreadcrumbs
        text-tag="h1"
        :items="breadcrumbs"
        class="pb-2xl"
      />
      <p
        class="whitespace-pre-line text-neutral-40"
        v-text="$t('agent.find.legal_notice')"
      />
    </IadWrapper>
    <PropertySerpStickyCta />
  </div>
</template>
